import tw from 'twin.macro';
import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';
import * as Sentry from '@sentry/nextjs';

import { Spinner } from '@restworld/ui-ds';

function Error({ statusCode }: { statusCode?: number }) {
  const { asPath } = useRouter();

  const isErrorPage = useMemo(() => asPath.includes('/posizione/') || asPath.includes('/locale/'), [asPath]);

  // Reload the page after 1 second
  useEffect(() => {
    if (!isErrorPage) return;
    setTimeout(() => {
      window?.location.reload();
    }, 1000);
  }, [isErrorPage]);

  if (isErrorPage)
    return (
      <ScreenSpinnerWrapper>
        <Spinner color="primary" size="lg" />
      </ScreenSpinnerWrapper>
    );
  return <p>An error occured on client {statusCode}</p>;
}

const ScreenSpinnerWrapper = tw.div`w-screen h-screen flex items-center justify-center`;

Error.getInitialProps = async (contextData) => {
  const { res, err } = contextData;
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  await Sentry.captureUnderscoreErrorException(contextData);
  return { statusCode };
};

export default Error;
